import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import cx from 'classnames';
import styles from './styles.module.scss';

const ClusterBalloonContentLayout = (ymaps) =>
	ymaps.templateLayoutFactory.createClass(
		renderToStaticMarkup(
			<div className={cx(styles.BalloonList)}>
				{'{% for geoObject in properties.geoObjects %}'}
				<div className={styles.Balloon}>
					<div className={styles.Balloon__ImageWrapper}>
						<img
							className={styles.Balloon__Image}
							src="{{ geoObject.properties.thumbnailImg }}"
							alt=""
							loading="lazy"
						/>
					</div>
					<div className={styles.Balloon__Body}>
						<a
							className={styles.Balloon__InstituteTitle}
							href="{{ geoObject.properties.url }}"
						>
							{'{{ geoObject.properties.title }}'}
						</a>
						<span className={styles.Balloon__InstituteLocation}>
							{'{{ geoObject.properties.address }}'}
						</span>
					</div>
				</div>
				{'{% endfor %}'}
			</div>
		)
	);

export default ClusterBalloonContentLayout;
